import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './context/AuthContext';
import { AgenteProvider } from './context/AgenteContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Registro from './pages/Registro';
import RecuperarContrasena from './pages/RecuperarContrasena';
import RestablecerContrasena from './pages/RestablecerContrasena';
import AppLayout from './layout/AppLayout';
import Dashboard from './pages/Dashboard';
import Agente from './pages/Agente';
import Playground from './pages/Playground';
import Conexion from './pages/Conexion';
import Plantillas from './pages/Plantillas';
import Conversaciones from './pages/Conversaciones';
import Agenda from './pages/Agenda';
import Integraciones from './pages/Integraciones';
import Pipeline from './pages/Pipeline';
import Suscripcion from './pages/Suscripcion';
import Perfil from './pages/Perfil';
import PreguntasFrecuentes from './pages/PreguntasFrecuentes';
import OtrosProyectos from './pages/OtrosProyectos';
import Orquestacion from './pages/Orquestacion';
import Flujos from './pages/Flujos';
import FlujoEditor from './pages/FlujoEditor';
import WooCommerce from './pages/WooCommerce';
import Soporte from './pages/Soporte';
import RedesSociales from './pages/RedesSociales';
import Admin from './pages/Admin';
import { Privacidad, Terminos } from './pages/Legal';

const Protected: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }
  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
      <Route path="/restablecer-contrasena" element={<RestablecerContrasena />} />
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="/terminos" element={<Terminos />} />
      <Route
        path="/app"
        element={
          <Protected>
            <AgenteProvider>
              <AppLayout />
            </AgenteProvider>
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="agente" element={<Agente />} />
        <Route path="playground" element={<Playground />} />
        <Route path="conexion" element={<Conexion />} />
        <Route path="plantillas" element={<Plantillas />} />
        <Route path="conversaciones" element={<Conversaciones />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="integraciones" element={<Integraciones />} />
        <Route path="orquestacion" element={<Orquestacion />} />
        <Route path="flujos" element={<Flujos />} />
        <Route path="flujos/:id" element={<FlujoEditor />} />
        <Route path="woocommerce" element={<WooCommerce />} />
        <Route path="redes-sociales" element={<RedesSociales />} />
        <Route path="soporte" element={<Soporte />} />
        <Route path="admin" element={<Admin />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="suscripcion" element={<Suscripcion />} />
        <Route path="otros-proyectos" element={<OtrosProyectos />} />
        <Route path="perfil" element={<Perfil />} />
        <Route path="faq" element={<PreguntasFrecuentes />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
